import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'frmg-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
  imports: [NgTemplateOutlet]
})
export class ContentTooltipComponent implements OnInit {
  @Input() contentTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit() {
  }
}
